import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, Validators } from '@angular/forms';
import { StaticPageService } from '../../../shared/services/static-page.service';
import { PdfReader } from '../../../shared/models/pages-model/form-general.model';
import { InputGeneral } from '../../../shared/inputs/input-general/input-general';
import { ReaderPdfComponent } from '../../../shared/inputs/reader-pdf/reader-pdf.component';

@Component({
  standalone: true,
  selector: 'app-promise-letter',
  templateUrl: './promise-letter.component.html',
  imports: [InputGeneral, ReaderPdfComponent, TranslateModule],
})
export class PromiseLetterComponent {
  @Input() quotationId: number | null = null;
  public ballon: FormControl = new FormControl(null, [Validators.required]);
  public field: PdfReader | null = null;

  constructor(private staticPageService: StaticPageService) {}

  ngOnInit(): void {
    this.getBallonInfo();
  }

  public getBallonInfo(): void {
    this.staticPageService.getBallonInfo(this.quotationId ?? 0).subscribe((ress) => {
      if (ress) {
        this.ballon.setValue(ress.n_BALLON);
      }
    });
  }

  public getCartaPromesa(): void {
    this.field = {
      label: 'label',
      roleType: 'reader-PDF',
      fieldName: 'reader-PDF',
      colFull: true,
      value: '',
      idControl: 0,
      idFullControl: `0`,
      disabled: false,
      error: {},
      rules: [],
      quotationId: this.quotationId ?? 0,
      url: '',
      bodyAux: this.ballon.value,
      view: true,
      typeInput: 'reader-PDF',
      order: 0,
      functionEvent: {
        event: {
          function: null,
          starFuntion: false,
          eventFuntion: false,
        },
        catalog: {
          url: null,
          nameParam: null,
          input: null,
          arrayParam: [],
        },
        ulrPDF: 'getCartaPromesa',
      },
    };
  }
}
